export default __webpack_public_path__ + "static/media/video-off.bce3562a.svg";